export const CHECKOUT_URL = 'https://hydroponics-grower-ready.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/miivRxWjJKF6EYBqndouhB/Diseno_sin_titulo_(72).png'

export const HERO_IMAGE_ALT =
  'Hydroponics Grower Ready complete system: 6 visual volumes, 6-in-1 visual growing system and 5 practical grower bonuses'

export const PRIMARY_CTA = 'GET HYDROPONICS GROWER READY NOW'

export interface IncludedItem {
  label: string
  kind: 'included' | 'bonus'
}

export const packageIncludes: IncludedItem[] = [
  { kind: 'included', label: 'Volume 1 — Hydroponics Setup & System Selection' },
  { kind: 'included', label: 'Volume 2 — Nutrients, pH, EC & Water Management' },
  { kind: 'included', label: 'Volume 3 — Germination, Roots & Early Plant Growth' },
  { kind: 'included', label: 'Volume 4 — Hydroponic Crop Mastery' },
  { kind: 'included', label: 'Volume 5 — Lighting, Climate & Yield Optimization' },
  { kind: 'included', label: 'Volume 6 — Hydroponics Troubleshooting & Recovery' },
  { kind: 'bonus', label: 'Hydroponics Quick-Start Blueprint' },
  { kind: 'bonus', label: 'Maintenance Calendar & System Control Checklist' },
  { kind: 'bonus', label: 'Hydroponic Deficiency & Symptom Visual Atlas' },
  { kind: 'bonus', label: 'Crop Planning & Harvest System' },
  { kind: 'bonus', label: 'Emergency Troubleshooting Flowcharts' },
  { kind: 'included', label: '100% Visual Main Growing System' },
  { kind: 'included', label: 'Immediate Digital Access' },
]
